export default __webpack_public_path__ + "static/media/elon3x.b74c359b.png";